import React, { useMemo } from "react";
import { usePickDayOrders, usePickDays, usePickWaves } from "data/hooks";
import { summarisePickDay } from "functions/pickDay";
import { pickDaySteps } from "functions/pickDaySteps";
import { findShortages, summariseShortages } from "functions/shortages";
import { PickDaySteps } from "./PickDaySteps";

/**
 * The stappenlijst for a screen that does not read the pick day itself (Pickrondes, Tekorten):
 * the same reads as Bestellingen - SWR shares them when that screen was open - and nothing until
 * they are in, so the list never shows a day as further along or behind than it is.
 */
const PickDayStepsBar = ({ pickDay, page }) => {
  const day = usePickDays(pickDay);
  const dayOrders = usePickDayOrders(pickDay);
  const { waves } = usePickWaves(pickDay);
  const stats = useMemo(() => summarisePickDay(dayOrders.orders), [dayOrders.orders]);
  const openShortages = useMemo(() => summariseShortages(findShortages(dayOrders.orders)).open, [dayOrders.orders]);
  if (!pickDay || day.isLoading || !dayOrders.isLoaded) return null;
  const model = pickDaySteps({ locked: !!day.locked, total: stats.total, unassigned: stats.unassigned, waves, openShortages });
  return <PickDaySteps pickDay={pickDay} deliveryDate={(day.deliveryDates || [])[0]} model={model} page={page} />;
};

export default PickDayStepsBar;
